export function PageSkeleton() {
  return (
    <div style={{ padding: '32px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <div className="skeleton" style={{ height: '32px', width: '240px', borderRadius: '8px' }} />
      <div className="skeleton" style={{ height: '120px', borderRadius: '12px' }} />
      <div className="skeleton" style={{ height: '400px', borderRadius: '12px' }} />
    </div>
  );
}
